import { Link } from "react-router-dom";
import img1 from "../../assets/images/npskudlu.jpg";

const AboutTwo = () => {
  return (
    <section className="about-two py-60 position-relative z-1">
      <div className="position-relative">
        <div className="container">
          {/* remove flex-wrap-reverse so image doesn't jump above/below unexpectedly */}
          <div className="row gy-xl-0 gy-5 align-items-center">
            {/* Image */}
            <div
              className="col-xl-6 pe-xl-5"
              data-aos="zoom-in"
              data-aos-duration="900"
            >
              <div className="about-two__thumb position-relative">
                <img
                  src={img1}
                  className="rounded-16 cover-img img-fluid"
                  alt="Campus at National Public School, Kudlu"
                  loading="lazy"
                  data-tilt=""
                  data-tilt-max={10}
                  data-tilt-speed={500}
                  data-tilt-perspective={5000}
                  data-tilt-full-page-listening=""
                />
              </div>
            </div>

            {/* Content */}
            <div className="col-xl-6">
              <div className="about-two-content">
                <div className="mb-40">
                  <div
                    className="flex-align d-inline-flex gap-8 mb-16"
                    data-aos="fade-down"
                    data-aos-duration="700"
                  >
                    <h5 className="text-main-600 mb-0">About Us</h5>
                  </div>

                  <h2
                    className="mb-24"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-delay="100"
                  >
                    We teach academic excellence, values, and discipline
                  </h2>

                  <p
                    className="text-neutral-500 text-line-2"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-delay="200"
                  >
                    National Public School comes under BANGALORE INSTITUTE FOR
                    HIGHER EDUCATION & RESEARCH Trust.
                    <br />
                    <br />
                    National Public School was established in 1982 with Dr. K.
                    P. Gopalkrishna serving as its Chairman. Highly skilled
                    personnel and modern teaching technology will be used by the
                    co-educational Kudlu school when it opens its doors this
                    year.
                    <br />
                    <br />
                    “National Public School Kudlu, being one of the top CBSE
                    schools in Bangalore, is committed to imparting high-quality
                    holistic education by giving students opportunities to
                    develop their creative and social skills through a wide
                    variety of programmes in a caring, innovative and healthy
                    environment. At NPS, we invoke a love of learning by
                    developing the intellectual, emotional, social, physical,
                    and creative potentials.”
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
